module.exports = __webpack_public_path__ + "static/banner-image-5-2285be346cd372cd1b47f2f1a8562f76.jpg";